import type { LoginError as LoginErrorType } from '../types/login';

export default class LoginError extends Error {
  errors: LoginErrorType[];

  constructor(errors: LoginErrorType[]) {
    super();
    this.name = 'LoginError';
    this.errors = errors;
  }
}
